import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
export interface IHorizontalRule extends IBaseElementProps {
}

const sizeParameter = {
    size: '4'
}

/**
 * Horizontal Rule
 * @block
 * @requiresHooks
 * @icon minus
 */

const HorizontalRule: React.FC<IHorizontalRule> = ({
	className,
}) => (
	<hr className={className || cn('horizontal-rule', className)} {...sizeParameter} />
);

export default HorizontalRule;
